import { render, staticRenderFns } from "./NewItemAppHeader.vue?vue&type=template&id=6ad72aa9&scoped=true&"
import script from "./NewItemAppHeader.vue?vue&type=script&lang=js&"
export * from "./NewItemAppHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad72aa9",
  null
  
)

export default component.exports